import FormTabSaldo from "App/Component/layout/Tagihan/Saldo/ui/FormTabSaldo"
import { Modal } from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  defaultToastError,
  today,
  defaultToastSuccess,
  isNull,
  toUTCFormat,
  convertToValidPrice,
} from "App/utils/helpers"
import React, { useState, useContext } from "react"
import { FormContext } from "../../../../context/FormContext"

function ModalBayar({
  setShowModal,
  sisa = 0,
  kasBankID = null,
  kasBankName = "Pilih Kas",
}) {
  const { formData, setFormData } = useContext(FormContext)
  const [formBayar, setFormBayar] = useState({
    date: today(true),
    amount2: sisa,
    kas_id: kasBankID,
    tipe_pembayaran_id: 1,
    kas_name: kasBankName,
    tipe_kartu: 1,
    no_transaksi: "",
    no_kartu: "",
    nik_pegawai: null,
    kode_potongan: null,
  })

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const handleChange = (text) => (e) => {
    setFormBayar({
      ...formBayar,
      [text]: e.target.value,
    })
  }

  const save = async () => {
    const defaultData = {
      penjualan_id: formData.penjualan_id,
      tanggal_masuk: toUTCFormat(formBayar.date),
      jumlah_bayar: convertToValidPrice(formBayar.amount2),
      tipe_pembayaran_id: formBayar.tipe_pembayaran_id,
      kas_id: formBayar.kas_id,
      tipe_kartu: formBayar.tipe_kartu,
      no_transaksi: formBayar.no_transaksi,
      jenis_bayar: 1,
      no_kartu: formBayar.no_kartu,
      no_transfer: formBayar.no_transfer,
      kartu_bank: formBayar.kartu_bank,

      rm_id: formData.rm_id,
      no_asuransi: formData.noasuransi,
      asuransi_id: formData.asuransi_id,
      nama: formData.nama,
      nik_pegawai: formBayar?.nik_pegawai?.value ?? "",
      kode_potongan: formBayar?.kode_potongan?.value ?? "",
    }

    for (const key in defaultData) {
      if (isNull(defaultData[key]) || defaultData[key] === "-") {
        delete defaultData[key]
      }
    }

    return instance3.post("/bayar/pembayaranPerPenjualan", defaultData)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isNull(formData.penjualan_id)) {
      defaultToastError("Buka transaksi terlebih dahulu")
    } else {
      try {
        setDisabled(DISABLED_BUTTON_SUBMIT)
        const res = await save()
        if (res.data.status === 200) {
          defaultToastSuccess("Berhasil menambah pembayaran")
          setShowModal(false)
          setFormData({
            ...formData,
            pembayaran: convertToValidPrice(formBayar.amount2),
            tagihan_id: res.data.id_tagihan,
          })
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        } else {
          defaultToastError(res.data.message)
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  return (
    <Modal
      title="Pembayaran Penjualan External"
      width="50%"
      show={setShowModal}
    >
      <FormTabSaldo
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        formData={formBayar}
        setFormData={setFormBayar}
        disabled={disabled}
        isTagihan={true}
      />
    </Modal>
  )
}

export default ModalBayar
